import { TicketItem, Address, Money } from "../models"

export const OrderStates =  {
	COMPLETED: "abgeschlossen",
	CANCELED: "abgebrochen",
	READY_FOR_SHIPMENT: "bereit zum Versand",
	WAITING_FOR_SHIPMENT: "bereit zum Versand",
	ORDER_PLACED: "entgegengenommen",
	ACCEPTED: "bestätigt",
}

export class OrderData {
	uuid: string
	principalId: string
	merchantId: string
	paymentType: string
	shipmentType: string
	shipmentFee: Money;
	customerUUID: string
	customerRef: string
	customerFullName: string
	totalOrderPrice: Money
	orderPlacedAt: string
	orderState: string
	billingAddress: Address
	shippingAddress: Address
	ticketItems: TicketItem[]
	orderMessages: string[]
	id: number
	comment: string
}



// WEBPACK FOOTER //
// ./src/app/models/order-data.model.ts